import { InteractionStatus } from '@azure/msal-browser';
import { ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router';

import { useAuth } from './hooks/useAuth';

type ProtectedRouteProps = {
  children: ReactNode;
  redirectTo?: string;
};

export const ProtectedRoute = ({
  children,
  redirectTo = '/login',
}: ProtectedRouteProps) => {
  const { isAuthenticated, login, inProgress } = useAuth();

  useEffect(() => {
    // Automatically trigger login if not authenticated and not already in progress
    if (
      !isAuthenticated &&
      inProgress === InteractionStatus.None &&
      redirectTo === '/login'
    ) {
      login().catch((error: unknown) => {
        console.error('Auto-login failed:', error);
      });
    }
  }, [isAuthenticated, login, inProgress, redirectTo]);

  // Show loading while authentication is in progress
  if (inProgress !== InteractionStatus.None) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Authenticating...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
